<template>
  <v-dialog v-model="dialog.value" persistent max-width="900">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn rounded dark color="primary" v-on="{ ...dialogOn, ...tooltipOn }" @click="resetProperties">
            <v-icon>mdi-email</v-icon>
          </v-btn>
        </template>
        <span>Wyślij e-mail do grupy</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Wysyłka wiadomości e-mail do grupy</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-form ref="form">
          <v-text-field
            v-model="form.title"
            label="Tytuł"
            name="name"
            type="text"
            :error-messages="titleErrors"
            @input="$v.form.title.$touch()"
            @blur="$v.form.title.$touch()"
          />
          <div>
            <editor-menu-bar v-slot="{ commands, isActive }" :editor="editor">
              <v-container>
                <v-row>
                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.bold()"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.bold"
                        ><v-icon>mdi-format-bold</v-icon></v-btn
                      >
                    </template>
                    <span>Pogrubienie</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.italic()"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.italic"
                      >
                        <v-icon>mdi-format-italic</v-icon>
                      </v-btn>
                    </template>
                    <span>Kursywa</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.underline()"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.underline"
                      >
                        <v-icon>mdi-format-underline</v-icon>
                      </v-btn>
                    </template>
                    <span>Podkreślenie</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.strike()"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.strike"
                      >
                        <v-icon>mdi-format-strikethrough</v-icon>
                      </v-btn>
                    </template>
                    <span>Przekreślenie</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.code()"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.code"
                      >
                        <v-icon>mdi-code-tags</v-icon>
                      </v-btn>
                    </template>
                    <span>Kod</span>
                  </v-tooltip>

                  <v-spacer />

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.paragraph()"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.paragraph"
                      >
                        <v-icon>mdi-format-paragraph</v-icon>
                      </v-btn>
                    </template>
                    <span>Normalny</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.heading({ level: 1 })"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.heading({ level: 1 })"
                      >
                        <v-icon>mdi-format-header-1</v-icon>
                      </v-btn>
                    </template>
                    <span>Nagłówek 1</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.heading({ level: 2 })"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.heading({ level: 2 })"
                      >
                        <v-icon>mdi-format-header-2</v-icon>
                      </v-btn>
                    </template>
                    <span>Nagłówek 2</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.heading({ level: 3 })"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.heading({ level: 3 })"
                      >
                        <v-icon>mdi-format-header-3</v-icon>
                      </v-btn>
                    </template>
                    <span>Nagłówek 3</span>
                  </v-tooltip>

                  <v-spacer />

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="true"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.alignment({ textAlign: 'left' })"
                        ><v-icon>mdi-format-align-left</v-icon></v-btn
                      >
                    </template>
                    <span>Wyrównaj do lewej</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="true"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.alignment({ textAlign: 'center' })"
                        ><v-icon>mdi-format-align-center</v-icon></v-btn
                      >
                    </template>
                    <span>Wyrównaj do prawej</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="true"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.alignment({ textAlign: 'right' })"
                        ><v-icon>mdi-format-align-right</v-icon></v-btn
                      >
                    </template>
                    <span>Wyrównaj do środka</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="true"
                        x-small
                        color="primary"
                        class="mr-2"
                        v-on="on"
                        @click="commands.alignment({ textAlign: 'justify' })"
                        ><v-icon>mdi-format-align-justify</v-icon></v-btn
                      >
                    </template>
                    <span>Wyjustuj</span>
                  </v-tooltip>

                  <v-spacer />

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.bullet_list()"
                        x-small
                        color="primary"
                        class="mr-2"
                        :disabled="isActive.code_block()"
                        v-on="on"
                        @click="commands.bullet_list"
                      >
                        <v-icon>mdi-format-list-bulleted-square</v-icon>
                      </v-btn>
                    </template>
                    <span>Punktatory</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        :outlined="!isActive.ordered_list()"
                        x-small
                        color="primary"
                        class="mr-2"
                        :disabled="isActive.code_block()"
                        v-on="on"
                        @click="commands.ordered_list"
                      >
                        <v-icon>mdi-format-list-numbered</v-icon>
                      </v-btn>
                    </template>
                    <span>Numeracja</span>
                  </v-tooltip>

                  <v-spacer />

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn fab x-small color="primary" class="mr-2" v-on="on" @click="commands.undo">
                        <v-icon>mdi-undo</v-icon>
                      </v-btn>
                    </template>
                    <span>Cofnij</span>
                  </v-tooltip>

                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn fab x-small color="primary" class="mr-2" v-on="on" @click="commands.redo">
                        <v-icon>mdi-redo</v-icon>
                      </v-btn>
                    </template>
                    <span>Wykonaj ponownie</span>
                  </v-tooltip>
                </v-row>
              </v-container>
            </editor-menu-bar>
            <v-card outlined><editor-content class="text-lesson-edit__content pa-2" :editor="editor"/></v-card>

            <v-scroll-y-transition>
              <div v-if="bodyHasErrors" class="v-text-field__details mt-2">
                <div class="v-messages theme--light error--text" role="alert">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ bodyErrors[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </v-scroll-y-transition>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text--secondary" text :disabled="dialog.loading" @click="dialog.value = false">Anuluj</v-btn>
        <v-btn color="primary" text :loading="dialog.loading" @click="create">Wyślij</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { createNamespacedHelpers } from 'vuex';
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  Bold,
  BulletList,
  Code,
  CodeBlock,
  HardBreak,
  Heading,
  History,
  HorizontalRule,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Strike,
  TodoItem,
  TodoList,
  Underline
} from 'tiptap-extensions';
import GroupsServiceApi from '@/api/groupsServiceApi.js';
import { Alignment } from '@/plugins/tiptap/extensions';

const { mapActions } = createNamespacedHelpers('groups');
const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  components: {
    EditorContent,
    EditorMenuBar
  },
  mixins: [validationMixin],
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      },
      form: {
        title: null,
        body: 'Treść wiadomości'
      },
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Alignment()
        ],
        content: 'Treść wiadomości',
        onUpdate: this.onChange
      })
    };
  },
  computed: {
    ...mapAccountState(['token']),
    bodyHasErrors() {
      return !!this.bodyErrors.length;
    },
    titleErrors() {
      const errors = [];
      if (!this.$v.form.title.$dirty) {
        return errors;
      }
      if (!this.$v.form.title.required) {
        errors.push('Tytuł jest wymagany');
      }
      return errors;
    },
    bodyErrors() {
      const errors = [];
      if (!this.$v.form.body.$dirty) {
        return errors;
      }
      if (!this.$v.form.body.required) {
        errors.push('Treść wiadomości jest wymagana');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      body: {
        required: val => {
          return !(!val || val === '<p></p>');
        }
      }
    }
  },
  methods: {
    ...mapActions(['updateGroup']),
    resetProperties() {
      this.form.title = null;
      this.form.body = 'Treść wiadomości';
      this.$v.$reset();
    },
    onChange(ev) {
      this.form.body = ev.getHTML();
    },
    async create() {
      this.$v.$touch();

      if (this.formValid) {
        this.dialog.loading = true;

        try {
          await new GroupsServiceApi(this.token).sendMailingForGroup(this.form.title, this.form.body, this.group.id);
        } catch (e) {
          console.error(e);
          // TODO: handle
        } finally {
          this.dialog.loading = false;
          this.dialog.value = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.errors-box {
}
</style>
